exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accept-analysis .header[data-v-1d7263b4]{margin:20px}.accept-analysis .content .chart[data-v-1d7263b4]{width:500px;margin:0 auto;height:400px}.accept-analysis .content .pagination[data-v-1d7263b4]{text-align:right}\n", ""]);

// exports
